module.exports = __webpack_public_path__ + "img/products.189cd8fc.svg";